// extracted by mini-css-extract-plugin
module.exports = {"number_input":"InputNumber_number_input__1MUvD","plus":"InputNumber_plus__3sI-b","minus":"InputNumber_minus__1dkLd"};